import { useEffect } from 'react';
import { useNavigate } from 'react-router';

import { useIsExternalUrl } from '#/hooks/useIsExternalUrl';
import { getUrlWithoutOrigin } from '#/utils/url/getUrlWithoutOrigin';
import { isUrlWithProtocol } from '#/utils/url/isUrlWithProtocol';

type Props = {
  redirectPath: string;
};

export function CmsSplatHypernovaRedirect({ redirectPath }: Props) {
  const navigate = useNavigate();
  const { isExternalUrl } = useIsExternalUrl();

  useEffect(() => {
    if (isExternalUrl(redirectPath)) {
      window.location.href = redirectPath;
    } else {
      const normalizedRedirectPath = isUrlWithProtocol(redirectPath)
        ? getUrlWithoutOrigin(redirectPath)
        : redirectPath;
      void navigate(normalizedRedirectPath, { replace: true });
    }
  }, [navigate, redirectPath, isExternalUrl]);

  return null;
}
